<template>
    <Modal ref="Modal" :title="$t('labels.edit_orders')">
        <div class="modal-body">
            <FormGroup :label="$t('labels.status')" :required="true">
                <Autocomplete
                    :url="`/projects/${$route.params.projectUuid}/crm/statuses`"
                    :model-value="orderStatus?.uuid"
                    :selected-value="orderStatus?.name"
                    :can-be-empty="true"
                    :query-params="{
                        orders: [{
                            column: 'priority_order',
                            dir: 'asc'
                        }]
                    }"
                    @update:model-value="orderStatus = $event"
                >
                    <template #optionContent>
                        <span v-if="orderStatus" :class="`badge`" :style="{
                            'color': 'white',
                            'background-color': orderStatus?.color
                        }">{{ orderStatus?.name }}</span>
                        <span v-else class="text-muted">{{ $t('placeholders.missing') }}</span>
                    </template>
                    <template #optionItem="{option}">
                        <span :class="`badge`" :style="{
                            'color': 'white',
                            'background-color': option.color
                        }">{{ option.name }}</span>
                    </template>
                </Autocomplete>
            </FormGroup>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="indigo" @click="edit">
                <span>{{ $t('buttons.edit') }}</span>
            </Button>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../../components/new/modal/AppModal.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import Autocomplete from "../../../../../components/new/form/autocomplete/AppAutoComplete.vue";

import { httpClient } from "../../../../../services/HttpClient";
import MessageNotificator from "../../../../../services/MessageNotificator";
import { chunk } from "../../../../../utils"

export default {
    name: "EditOrdersModal",
    components: {
        Modal, FormGroup, Button, Autocomplete
    },
    data() {
        return {
            orderUuids: [],
            orderStatus: null
        }
    },
    methods: {
        show(orderUuids) {
            this.orderUuids = orderUuids
            this.$refs.Modal.show()
        },
        async edit() {
            await Promise.all(chunk(this.orderUuids, 10).map((orderUuids) => {
                return httpClient.post(`/batch`, {
                    data: orderUuids.map((orderUuid) => ({
                        method: 'PATCH',
                        path: `/projects/${this.$route.params.projectUuid}/crm/orders/${orderUuid}`,
                        body: {
                            status_uuid: this.orderStatus?.uuid ?? null
                        }
                    }))
                })
            }))

            new MessageNotificator().success(this.$t('alerts.success'))
            this.$refs.Modal.hide()
            this.orderStatus = null
            this.$emit('update:table')
        }
    }
}
</script>